// AIDEV-NOTE: Botoes de exportacao PDF e Excel para relatorios
import { Button, ButtonGroup } from '@mui/material';
import { pdf, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import * as XLSX from 'xlsx';

const pdfStyles = StyleSheet.create({
  page: { padding: 30 },
  title: { fontSize: 18, marginBottom: 15 },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingVertical: 4
  },
  cell: { flex: 1, fontSize: 10 },
  headerCell: { flex: 1, fontSize: 10, fontWeight: 'bold' }
});

interface ExportButtonProps {
  title: string;
  columns: { field: string; headerName: string }[];
  rows: Record<string, unknown>[];
}

function ReportPdf({ title, columns, rows }: ExportButtonProps) {
  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <Text style={pdfStyles.title}>{title}</Text>
        <View style={pdfStyles.row}>
          {columns.map((col) => (
            <Text key={col.field} style={pdfStyles.headerCell}>
              {col.headerName}
            </Text>
          ))}
        </View>
        {rows.map((row, idx) => (
          <View key={idx} style={pdfStyles.row}>
            {columns.map((col) => (
              <Text key={col.field} style={pdfStyles.cell}>
                {String(row[col.field] ?? '')}
              </Text>
            ))}
          </View>
        ))}
      </Page>
    </Document>
  );
}

async function exportPdf(
  title: string,
  columns: ExportButtonProps['columns'],
  rows: ExportButtonProps['rows']
) {
  const blob = await pdf(<ReportPdf title={title} columns={columns} rows={rows} />).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title.replace(/\s+/g, '_')}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

function exportExcel(
  title: string,
  columns: ExportButtonProps['columns'],
  rows: ExportButtonProps['rows']
) {
  const header = columns.map((c) => c.headerName);
  const data = rows.map((row) => columns.map((c) => row[c.field] ?? ''));
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Relatorio');
  XLSX.writeFile(wb, `${title.replace(/\s+/g, '_')}.xlsx`);
}

export function ExportButton({ title, columns, rows }: ExportButtonProps) {
  return (
    <ButtonGroup variant="outlined" size="small" sx={{ mb: 2 }}>
      <Button onClick={() => exportPdf(title, columns, rows)}>PDF</Button>
      <Button onClick={() => exportExcel(title, columns, rows)}>Excel</Button>
    </ButtonGroup>
  );
}
